<template>
  <img :src="src" alt="" :class="fileInfo.type === 'image' && 'w-100'" />
</template>

<script>
import { SUPPORTED_EXT } from "@/modules/file";

export default {
  name: "fmFilePreview",
  props: {
    file: { type: Object, default: null }
  },
  data() {
    return {
      preview: ''
    }
  },
  computed: {
    fileData() {
      return this.file || {}
    },
    fileInfo() {
      let type = '', ext = ''
      type = this.enums('fileType', 'value', this.fileData.Type, 'key')
      ext = this.fileData.Extension.replace('.', '')
      return { type, ext }
    },
    src() {
      if (this.fileInfo.type === 'image') return this.preview
      let supported = SUPPORTED_EXT.includes(this.fileInfo.ext)
      let icon = supported ? this.fileInfo.ext : 'blank'
      return require(`@/assets/images/file-types/${icon}.png`)
    }
  },
  watch: {
    file: {
      immediate: true,
      handler: 'setPreview'
    }
  },
  methods: {
    setPreview() {
      let payload = this.fileData.Path
      this.preview = ''
      if (this.fileInfo.type !== 'image') return
      if (payload instanceof File) {
        let reader = new FileReader()
        reader.onloadend = () => (this.preview = reader.result)
        reader.readAsDataURL(payload)
      } else {
        this.preview = payload
      }
    }
  }
}
</script>